import {
    DEALERREQWITHDRAWEMONEY_SUCCESS,
    DEALERREQWITHDRAWEMONEY_FAILED,
    RESET_DEALERREQWITHDRAWEMONEY,
    LOADING_DEALERREQWITHDRAWEMONEY,
    NETWORK_ERROR_DEALERREQWITHDRAWEMONEY
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERREQWITHDRAWEMONEY:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERREQWITHDRAWEMONEY_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERREQWITHDRAWEMONEY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERREQWITHDRAWEMONEY:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERREQWITHDRAWEMONEY:
            return (state = initialState);
        default:
            return state;
    }
};
